import React from 'react'
import { Tabs, Modal, Button, Badge, Table, Message } from 'antd'
import { getStockWarningList } from '../../../api/businessCommodity'
import Info from './info'
import Selling from './selling'
import Storing from './storing'
import PullOffShelves from './pullOffShelves'
import BatchList from './batchList'
import Dispatch from './dispatch'
import ReturnStore from './returnStore'
import StoreRecord from './storeRecord'
import { AlipaySquareFilled } from '@ant-design/icons'

const { TabPane } = Tabs

export default class extends React.Component {
  state = {
    isVisible: false,
    title: '',
    activeTab: '1',
    detailTab: '1',
    modalState: '',
    confirmLoading: false,
    allData: {},
    stockWarningCountList: [],
    newListingId: '',
    isNonStandard: false,
    currentId: '',
  }

  constructor(props) {
    super(props)
    this.newInfoRef = React.createRef()
    this.detailInfoRef = React.createRef()
    this.sellingRef = React.createRef()
    this.storingRef = React.createRef()
    this.listStoringRef = React.createRef()
    this.dispatchRef = React.createRef()
    this.returnStoreRef = React.createRef()
  }

  componentDidMount() {
    this.forceUpdate()
  }

  openModal = (title, thisListData) => {
    if (title == '新增商品') {
      this.setState({
        modalState: 'isAddCommodity',
        activeTab: '1',
      })
    }
    if (title == '下架商品') {
      this.setState({
        modalState: 'isPullOff',
        activeTab: '1',
      })
    }
    if (title == '商品详情') {
      this.setState({
        modalState: 'isDetails',
        activeTab: '1',
      })
    }
    if (title == '商品进货') {
      this.setState({
        modalState: 'isStore',
        activeTab: '1',
      })
    }
    if (title == '商品调拨') {
      this.setState({
        modalState: 'isDispatch',
        activeTab: '1',
      })
    }
    if (title == '商品退库') {
      this.setState({
        modalState: 'isReturnStore',
        activeTab: '1',
      })
    }
    if (title == '商品流水') {
      this.setState({
        modalState: 'isStatement',
      })
    }
    if (title) {
      this.setState({
        isVisible: true,
        title: title,
      })
      return
    }
    this.setState({ isVisible: true })
  }
  setLoading = (flag) => {
    this.setState({ confirmLoading: flag })
  }
  handleOk = () => {
    const { modalState, activeTab, detailTab } = this.state
    if (modalState == 'isAddCommodity') {
      if (activeTab == '1') {
        this.newInfoRef.current.postNewCommodity()
      }
      if (activeTab == '2') {
        this.sellingRef.current.postNewSelling()
      }
      if (activeTab == '3') {
        this.storingRef.current.postNewStoring(false)
      }
    }

    if (modalState == 'isDetails') {
      if (detailTab == '1') {
        this.detailInfoRef.current.postNewCommodity()
      }
      if (detailTab == '2') {
        this.sellingRef.current.postNewSelling()
      }
    }

    if (modalState == 'isStore') {
      this.listStoringRef.current.postNewStoring(true)
    }

    if (modalState == 'isDispatch') {
      this.dispatchRef.current.postDispatch()
    }

    if (modalState == 'isReturnStore') {
      this.returnStoreRef.current.postReturnStore()
    }
  }
  saveNon = () => {
    this.storingRef.current.postNewStoring(true)
  }
  onCancel = () => {
    this.setState({ isVisible: false })
  }

  getAllData = () => {
    this.setState({
      allData: this.detailInfoRef.current.state.allData,
    })
  }

  getStockList = async () => {
    const { data, status, detail } = await getStockWarningList(
      this.state.allData.commodity.id
    )
    if (status == 1) {
      this.setState({ stockWarningCountList: data })
    } else {
      Message.error(detail)
    }
  }

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab }, () => {
      if (tab == 2) {
        this.getIdFromInfo()
        this.setConfirmLoading(false)
      }
    })
  }

  setIsVisible = (flag) => {
    this.setState({ isVisible: flag })
  }

  setConfirmLoading = (loading) => {
    this.setState({ confirmLoading: loading })
  }

  getIdFromInfo = (key, value) => {
    this.setState(
      { newListingId: this.newInfoRef.current.state.newListingId },
      () => {
        this.sellingRef.current.setNewListingId(
          this.newInfoRef.current.state.newListingId
        )
      }
    )
  }

  getOldIdFromInfo = (key, value) => {
    this.setState({
      currentId: this.detailInfoRef.current.state.allData.price.id,
    })
    // console.log(this.detailInfoRef.current.state)
  }

  prevStep = (num) => {
    this.setState({ activeTab: num })
  }

  setIsNonStandard = (flag) => {
    this.setState({ isNonStandard: flag })
  }

  render() {
    const onChange = (key) => {
      // console.log(key)
    }
    const detailTabChange = (key) => {
      this.setState({ detailTab: key })
      if (key == 3) {
        this.getStockList()
      }
    }
    const {
      isVisible,
      title,
      confirmLoading,
      modalState,
      activeTab,
      newListingId,
    } = this.state

    const buttons = [
      <Button key="cancel" onClick={this.onCancel}>
        取消
      </Button>,

      activeTab == '2' || activeTab == '3' ? (
        <Button
          key="prev"
          onClick={() => {
            if (activeTab == '2') {
              this.prevStep('1')
            } else if (activeTab == '3') {
              this.prevStep('2')
            }
          }}
        >
          上一步
        </Button>
      ) : (
        ''
      ),

      modalState != 'isStatement' ? (
        <Button
          key="submit"
          type="primary"
          onClick={this.handleOk}
          loading={confirmLoading}
        >
          保存
        </Button>
      ) : (
        ''
      ),

      activeTab == '3' ? (
        <Button
          key="upload"
          type="primary"
          onClick={this.saveNon}
          loading={confirmLoading}
        >
          保存并上架
        </Button>
      ) : (
        ''
      ),
    ]

    const columns = [
      {
        title: 'id',
        dataIndex: ['store', 'id'],
      },
      {
        title: '仓库名称',
        dataIndex: ['store', 'name'],
      },
      {
        title: '数量',
        dataIndex: 'quantity',
        render: (text, record, index) => {
          if (record.isNonStandard) {
            return '-'
          } else {
            return text
          }
        },
      },
      {
        title: '缺货提醒',
        dataIndex: 'isStockWarning',
        render: (text, record, index) => {
          return (
            <Button size="small" type={text ? 'danger' : 'primary'}>
              {text ? '是' : '否'}
            </Button>
          )
        },
      },
    ]

    return (
      <Modal
        visible={isVisible}
        title={title}
        onCancel={this.onCancel}
        confirmLoading={confirmLoading}
        footer={buttons}
        width="900px"
        // destroyOnClose={modalState == 'isDetails' ? true : false}
        destroyOnClose={true}
      >
        {modalState == 'isAddCommodity' ? (
          <Tabs activeKey={activeTab} onChange={onChange}>
            <TabPane
              tab="信息"
              key="1"
              disabled={modalState == 'isAddCommodity' && activeTab !== 1}
            >
              <Info
                categoryList={this.props.categoryList}
                allData={this.props.allData}
                modalState={modalState}
                setActiveTab={this.setActiveTab}
                setConfirmLoading={this.setConfirmLoading}
                getIdFromInfo={this.getIdFromInfo}
                setIsNonStandard={this.setIsNonStandard}
                ref={this.newInfoRef}
              ></Info>
            </TabPane>

            <TabPane
              tab="销售"
              key="2"
              disabled={modalState == 'isAddCommodity' && activeTab !== 2}
            >
              <Selling
                newListingId={newListingId}
                modalState={modalState}
                setIsVisible={this.setIsVisible}
                setActiveTab={this.setActiveTab}
                setConfirmLoading={this.setConfirmLoading}
                ref={this.sellingRef}
              ></Selling>
            </TabPane>

            <TabPane
              tab="库存"
              key="3"
              disabled={modalState == 'isAddCommodity' && activeTab !== 3}
            >
              <Storing
                storeList={this.props.storeList}
                newListingId={newListingId}
                modalState={modalState}
                setIsVisible={this.setIsVisible}
                setActiveTab={this.setActiveTab}
                setConfirmLoading={this.setConfirmLoading}
                getList={this.props.getList}
                isNonStandard={this.state.isNonStandard}
                ref={this.storingRef}
              ></Storing>
            </TabPane>
          </Tabs>
        ) : (
          ''
        )}

        {modalState == 'isPullOff' ? <PullOffShelves></PullOffShelves> : ''}

        {modalState == 'isDetails' ? (
          <Tabs onChange={detailTabChange}>
            <TabPane tab="信息" key="1">
              <Info
                categoryList={this.props.categoryList}
                modalState={this.state.modalState}
                chosenItem={this.props.chosenItem}
                getAllData={this.getAllData}
                setConfirmLoading={this.setConfirmLoading}
                setIsVisible={this.setIsVisible}
                getOldIdFromInfo={this.getOldIdFromInfo}
                setIsNonStandard={this.setIsNonStandard}
                getList={this.props.getList}
                ref={this.detailInfoRef}
              ></Info>
            </TabPane>
            <TabPane tab="销售" key="2">
              <Selling
                allData={this.state.allData}
                modalState={this.state.modalState}
                setConfirmLoading={this.setConfirmLoading}
                setIsVisible={this.setIsVisible}
                newListingId={newListingId}
                ref={this.sellingRef}
                currentId={this.state.currentId}
                getList={this.props.getList}
              ></Selling>
            </TabPane>

            <TabPane
              tab={
                <Badge dot={this.state.allData.isStockWarning == true}>
                  库存总量
                </Badge>
              }
              key="3"
            >
              <Table
                rowKey={(record, index) => index}
                bordered
                columns={columns}
                dataSource={this.state.stockWarningCountList}
                className="mt-20"
              ></Table>
            </TabPane>
            <TabPane
              tab={
                <Badge dot={this.state.allData.isExpirationWarning == true}>
                  批次记录
                </Badge>
              }
              key="4"
            >
              <BatchList allData={this.state.allData}></BatchList>
            </TabPane>
          </Tabs>
        ) : (
          ''
        )}

        {modalState == 'isStore' ? (
          <Storing
            storeList={this.props.storeList}
            modalState={modalState}
            setIsVisible={this.setIsVisible}
            setConfirmLoading={this.setConfirmLoading}
            chosenItem={this.props.chosenItem}
            ref={this.listStoringRef}
            getList={this.props.getList}
          ></Storing>
        ) : (
          ''
        )}

        {modalState == 'isDispatch' ? (
          <Dispatch
            storeList={this.props.storeList}
            modalState={modalState}
            setIsVisible={this.setIsVisible}
            setConfirmLoading={this.setConfirmLoading}
            chosenItem={this.props.chosenItem}
            ref={this.dispatchRef}
          ></Dispatch>
        ) : (
          ''
        )}

        {modalState == 'isReturnStore' ? (
          <ReturnStore
            storeList={this.props.storeList}
            modalState={modalState}
            setIsVisible={this.setIsVisible}
            setConfirmLoading={this.setConfirmLoading}
            chosenItem={this.props.chosenItem}
            ref={this.returnStoreRef}
            getList={this.props.getList}
          ></ReturnStore>
        ) : (
          ''
        )}

        {modalState == 'isStatement' ? (
          <StoreRecord chosenItem={this.props.chosenItem}></StoreRecord>
        ) : (
          ''
        )}
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/commodityDetail.js